import validator from 'validator';
import chunk from 'lodash/chunk';

export const REQUIRE = 'require';
export const TWOFA = 'twoFA';
export const PASSWORD = 'PASSWORD';
export const EMAIL = 'EMAIL';
export const INVOICE = 'INVOICE';
export const CREDIT_CARD_NUMBER = 'CREDIT_CARD_NUMBER';
export const CREDIT_CARD_EXPIRED_DATE = 'CREDIT_CARD_EXPIRED_DATE';
export const CREDIT_CARD_CVC = 'CREDIT_CARD_CVC';
export const LICENSE_PLATE = 'LICENSE_PLATE';
export const WRONG_FORMAT = 'wrong-format';

export const formatter = (payload, splitValue, groupSize) => {
  // 去除 space -> split 後用 chunk 分組 -> 將每組結合成字串 -> 合併
  let subStr = splitValue === ' ' ? /\s/g : splitValue;
  return chunk(payload.replace(subStr, '').split(''), groupSize)
    .map(num => num.join(''))
    .join(splitValue);
};

export const fieldCheck = (type, value) => {
  switch (type) {
    case REQUIRE:
      return requireStrategy(value);
    case TWOFA:
      return twoFAStrategy(value);
    case PASSWORD:
      return updatePasswordStrategy(value);
    case EMAIL:
      return emailStrategy(value);
    case INVOICE:
      return invoiceStrategy(value);
    case CREDIT_CARD_NUMBER:
      return creditCardNumberStrategy(value);
    case CREDIT_CARD_EXPIRED_DATE:
      return creditCardExpiredDateStrategy(value);
    case CREDIT_CARD_CVC:
      return creditCardCVCStrategy(value);
    case LICENSE_PLATE:
      return licensePlateStrategy(value);
    default:
      return false;
  }
};

export const passAll = { success: true, error: '' };

export const failPass = (code, message) => {
  const failMessage = () => {
    switch (code) {
      case REQUIRE:
        return '此欄位為必填';
      case WRONG_FORMAT:
        return '格式錯誤';
      default:
        return message;
    }
  };

  return { success: false, error: failMessage(), code };
};

const requireStrategy = value => {
  if (!value) return failPass(REQUIRE);
  return passAll;
};

const twoFAStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match('[0-9]{6}')) return failPass('', '請輸入 6 位數字');
  return passAll;
};

const updatePasswordStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match(`${PASSWORD_CHAR_REGEX}{8}`)) return failPass('', '密碼最少輸入 8 個字元');
  return passAll;
};

const emailStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!validator.isEmail(value)) return failPass(WRONG_FORMAT);
  return passAll;
};

const invoiceStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match('[0-9]{8}')) return failPass('', '請輸入 8 位數字');
  return passAll;
};

const creditCardNumberStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match('^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$')) return failPass(WRONG_FORMAT);
  return passAll;
};

const creditCardExpiredDateStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match('^((1[0-2]{1})|(0[1-9]{1}))/[0-9]{1}[0-9]{1}$')) return failPass(WRONG_FORMAT);
  return passAll;
};

const creditCardCVCStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (!value.match('^[0-9]{3}')) return failPass(WRONG_FORMAT);
  return passAll;
};

export const licensePlateStrategy = value => {
  if (!value) return failPass(REQUIRE);
  if (
    !(
      value.match('^[0-9A-Z]{2}-[0-9A-Z]{2}$') ||
      value.match('^[0-9A-Z]{2}-[0-9A-Z]{3}$') ||
      value.match('^[0-9A-Z]{2}-[0-9A-Z]{4}$') ||
      value.match('^[0-9A-Z]{3}-[0-9A-Z]{2}$') ||
      value.match('^[0-9A-Z]{3}-[0-9A-Z]{3}$') ||
      value.match('^[0-9A-Z]{3}-[0-9A-Z]{4}$') ||
      value.match('^[0-9A-Z]{4}-[0-9A-Z]{2}$')
    )
  )
    return failPass(WRONG_FORMAT);
  return passAll;
};

export const isPhoneNumber = input => {
  return input.match('09[0-9]{8}') !== null;
};

export const isReceiptCarrierCitizenDigitalNumber = input => {
  return input.match('[A-Z]{2}[0-9]{14}') !== null;
};

export const isReceiptCarrierMobileBarcode = input => {
  return input.match(`^/[0-9A-Z+-.]{7}$`) !== null;
};

export const isReceiptB2b = input => {
  return input.match('[0-9]{8}') !== null;
};

// 密碼僅允許 ASCII code 的字元
export const PASSWORD_CHAR_REGEX = '[\x00-\x7F]';
